import { Component, OnInit, HostListener } from "@angular/core";
import { DashboardService } from "../dashboard.service";
import { ActivatedRoute, Router, NavigationExtras } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import {
  ConfirmDialogModel,
  ConfirmationDialogComponent,
} from "src/app/confirmation-dialog/confirmation-dialog.component";
import { MatDialog } from "@angular/material";

@Component({
  selector: "app-third-party-users",
  templateUrl: "./third-party-users.component.html",
  styleUrls: ["./third-party-users.component.scss"],
})
export class ThirdPartyUsersComponent implements OnInit {
  @HostListener("getThirdPartyUser")
  private ResponseVerifiedgetThirdPartyUser$: Subject<any> = new Subject();
  private ResponseVerifiedChangeDeviceStatus$: Subject<any> = new Subject();

  key: any;
  devices: any = [];
  dataObject: any = {};
  role: any;
  page: any = 1;
  roleName: string;
  search: any = "";
  limit: any = 10;
  offset: any = 0;
  srcString: any = "";
  editUserAccessResquestObject: any = {};
  count: any;
  SadminAccess: any = [];
  access: any;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private dashboardService: DashboardService,
    private toastr: ToastrService
  ) {
    this.role = localStorage.role;
    if (this.role == "1") {
      this.roleName = "admin";
    } else if (this.role == "2") {
      this.roleName = "epc";
    } else if (this.role == "5") {
      this.roleName = "slave_admin";
    }
  }

  ngOnInit() {
    this.SadminAccess = JSON.parse(
      localStorage.getItem("SadminAccess") || "[]"
    );

    if (localStorage.SadminAccess != undefined) {
      this.SadminAccess.forEach((x) => {
        if (x.menu_name == "Device Inventory") {
          this.access = x.access;
        }
      });
    }
    if (this.roleName == "admin" || this.roleName == "slave_admin") {
      this.getThirdPartyUser(this.search, 0);
    }
  }

  // get All Devices For admin User
  getThirdPartyUser(search, offset): void {
    if (offset == 0) {
      this.page = 1;
    }
    this.dataObject = {
      search: search,
      limit: this.limit,
      offset: offset,
    };
    this.dashboardService
      .getThirdPartyUser(this.dataObject)
      .pipe(takeUntil(this.ResponseVerifiedgetThirdPartyUser$))
      .subscribe(
        async (data) => {
          this.count = 0;
          this.devices = [];
          if (data.status) {
            this.count = data.count;
            this.devices = data.resultObject;
          } else if (!data.status) {
            if (data.message == "Unauthorised or Login Time-out") {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        (err) => {
          return console.error(err);
        }
      );
  }

  editUserAccess(deviceId) {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        id: deviceId,
      },
    };
    this.router.navigate(["/inject-solar/add-third-party/"], navigationExtras);
  }

  nextPageNew(pageIndex): void {
    this.offset = (pageIndex - 1) * 10;
    this.getThirdPartyUser(this.srcString, this.offset);
  }

  public confirmDialog(id: any): void {
    let message = "Are you sure you want to delete this user?";
    let title = "Confirm Action";
    const dialogData = new ConfirmDialogModel(title, message);
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.deleteUserAccess(id);
      }
    });
  }
  deleteUserAccess(id): void {
    var dataObject = {
      id: id,
    };
    this.dashboardService
      .deleteThirdParty(dataObject)
      .pipe(takeUntil(this.ResponseVerifiedgetThirdPartyUser$))
      .subscribe(
        async (data) => {
          if (data.status) {
            // this.count = data.count;
            // this.devices = data.resultObject;
            this.toastr.success(data.message);
            this.getThirdPartyUser(this.search, this.offset);
          } else if (!data.status) {
            if (data.message == "Unauthorised or Login Time-out") {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        (err) => {
          return console.error(err);
        }
      );
  }
  //change device status


  ngOnDestroy() {
    this.ResponseVerifiedgetThirdPartyUser$.next();
    this.ResponseVerifiedgetThirdPartyUser$.complete();

    this.ResponseVerifiedChangeDeviceStatus$.next();
    this.ResponseVerifiedChangeDeviceStatus$.complete();
  }
}
